import { PortfolioWeights } from "@/services/custom-portfolio/custom-portfolio-weights";
import { ChartData } from "chart.js";

export const extractCustomPortfolioWeightsData = ({
  data,
}: {
  data: PortfolioWeights;
}): ChartData<"bar" | "line"> | null => {
  if (data.length === 0) return null;

  const labels = [...new Set(data.map((item) => item.date))];
  const symbols = [
    ...data.reduce((acc, item) => {
      Object.keys(item).forEach((key) => {
        if (key !== "date") {
          acc.add(key);
        }
      });
      return acc;
    }, new Set<string>()),
  ];
  const colorsMap = getColorsMap({ symbols });

  const datasets = symbols.map((symbol) => ({
    label: symbol,
    backgroundColor: colorsMap.get(symbol),
    borderColor: colorsMap.get(symbol),
    data: labels.map((date) => {
      const dataPoint =
        (data.find((item) => item.date === date)?.[symbol] as number) ?? 0;
      return dataPoint;
    }),
  }));

  return {
    labels,
    datasets,
  };
};

function getColorsMap({ symbols }: { symbols: string[] }) {
  const sourceColorsMap = new Map<string | number, string>([
    [0, "#2D80AFCC"],
    [1, "#003D70CC"],
    [2, "#FDB62BCC"],
    [3, "#F67F13CC"],
    [4, "#EA4335CC"],
    [5, "#1f77b4"],
    [6, "#ff7f0e"],
    [7, "#2ca02c"],
    [8, "#d62728"],
    [9, "#9467bd"],
    [10, "#8c564b"],
    [11, "#e377c2"],
    [12, "#7f7f7f"],
    [13, "#bcbd22"],
    [14, "#17becf"],
    [15, "#aec7e8"],
    [16, "#ffbb78"],
    [17, "#98df8a"],
    [18, "#ff9896"],
    [19, "#c5b0d5"],
    [20, "#c49c94"],
  ]);
  let index = 0;
  const colorsMap = new Map<string | number, string>();
  symbols.forEach((symbol) => {
    colorsMap.set(symbol, sourceColorsMap.get(index++) ?? "");
  });
  return colorsMap;
}
